import React from 'react';
import { FormattedMessage } from 'react-intl';

const IntlMessages = (props) => <FormattedMessage {...props} />;

export default IntlMessages;
